export default __webpack_public_path__ + "static/media/eatingtimes_2@3x.9d607c35.jpg";